






































import { defineComponent, reactive } from "@vue/composition-api";

import { PROFILE_DEFAULT, THEME_DEFAULT } from "@/data";
import { RequiredCssProperty } from "@/models";
import { setCssRootVariable } from "@/utils";

import AboutMe from "@/components/default/about-me.vue";
import Banner from "@/components/default/banner.vue";
import ContactMe from "@/components/default/contact-me.vue";
import HobbyList from "@/components/default/hobby-list.vue";
import SkillSet from "@/components/default/skill-set.vue";

export default defineComponent({
  name: "HomeDefault",
  components: { AboutMe, Banner, ContactMe, HobbyList, SkillSet },

  setup() {
    Object.keys(THEME_DEFAULT.cssVariables).forEach(cssVar =>
      setCssRootVariable(
        cssVar,
        THEME_DEFAULT.cssVariables[cssVar as RequiredCssProperty] as string
      )
    );

    // theme
    const social = reactive({
      links: [
        {
          href: "https://github.com/Al-un",
          img: require("@/assets/brands/github/GitHub-Mark-Light-32px.png"),
          title: "Github"
        },
        {
          href: "https://medium.com/@Al_un",
          img: require("@/assets/brands/medium/monogram/Monogram.svg"),
          title: "Medium"
        },
        {
          href: "https://stackoverflow.com/users/4906586/al-un",
          img:
            "https://cdn.sstatic.net/Sites/stackoverflow/company/img/logos/so/so-icon.svg?v=f13ebeedfa9e",
          title: "Stack Overflow"
        },
        {
          href: "https://www.strava.com/athletes/47821410",
          img: require("@/assets/brands/strava/strava_symbol_orange.png"),
          title: "Strava"
        }
      ]
    });

    return {
      profile: PROFILE_DEFAULT,
      theme: THEME_DEFAULT,
      social
    };
  }
});
